import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DetailsService {

    constructor(
        private http: HttpClient
    ) { }

    getSchedule(teamId: string, seasonStarting?, partner?, seasonId?: string) {
        return this.http.post<any>('api_endpoint' + '/dual-match/schedule', { teamId, seasonStarting, partner, seasonId });
    }
}
